<template>
    <div class="magnifier col-12 text-center no-padding">
        <img
            :src="src"
            :data-zoom-image="src"
            ref="activeProductImage"
            id="active-product-image"
            class="main-product-image"
            :alt="alt"
        />
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
          src: {
            required: true,
            type: String,
          },
          alt: {
            required: false,
            type: String,
            default: "No Alt"
          }
        },

        data: function () {
            return {
                'activeImage': null,
                'activeImageElement': null,
            }
        },

        mounted: function () {
            // store image related info in global variables
            this.activeImageElement = this.$refs.activeProductImage;

            // convert into jQuery object
            this.activeImage = new jQuery.fn.init(this.activeImageElement);

            this.elevateZoom();

            this.$root.$on('changeMagnifiedImage', ({smallImageUrl, largeImageUrl}) => {
                this.activeImageElement.src = smallImageUrl;

                this.activeImage.data('zoom-image', (largeImageUrl ? largeImageUrl : smallImageUrl));

                this.elevateZoom();
            });
        },

        methods: {
            'elevateZoom': function () {
                this.activeImage.ezPlus({
                    cursor: 'pointer',
                    scrollZoom: false,
                    zoomWindowWidth: 400,
                    zoomWindowHeight: 400,
                    enable: false,
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/Resources/assets/js/UI/components/image-magnifier.vue